export const safeJSONParse = str => {
  try {
    return [null, JSON.parse(str)];
  } catch (err) {
    return [err, null];
  }
};
//# sourceMappingURL=json.js.map